import axios from 'axios'
import { objectSnakeToCamelCase, objectCamelToSnakeCase } from '@/util/libUtil'

const state = () => ({
    // Objeto que almacena los agendados del comercial
    isOpenMove: false,
    agendados: [],
    requestedAgendados: false,
    selectedComercial: null,
    rangoDate: null,
    // Rutas a la api
    paths: {
        ttClienteAgendadosPath: '/api/clientes/agendados/',
        agenadadoPath: '/api/atenciones/agendado/',
        moveScheduledPath: '/api/atenciones/move-scheduled/'
    }
})

const actions = {
    async updateAgendado({ commit, dispatch, getters, state }, { id, data }) {
        try {
            const resp = await axios.put(`${getters.getEndpointFromPath(state.paths.agenadadoPath)}${id}/`, objectCamelToSnakeCase(data));
            return objectSnakeToCamelCase(resp.data);
        } catch (error) {
            dispatch('util/showStatusSnackBar', {
                statusType: 'error',
                message: 'No se puede actualizar agendado',
            }, { root: true })
        }
    },
    async moveScheduled({ dispatch, state, getters }, { origin, destination }) {
        // try{
        await axios.post(getters.getEndpointFromPath(state.paths.moveScheduledPath), { 'origin': origin, 'destination': destination })

        dispatch('util/showStatusSnackBar', {
            statusType: 'success',
            message: 'Agendados movidos correctamente!',
        }, { root: true })
        // }
        // catch (error) {
        //     dispatch('util/showStatusSnackBar', {
        //         error: error,
        //         timeout: 8000,
        //         statusType: 'error',
        //         message: 'Error Mover Agendados',
        //     }, { root: true })
        // }
    },
    async fetchAgendados({ commit, getters, state }, { start, end }) {
        let params = {
            range: [start.date, end.date]
        }
        if (state.selectedComercial) params = { ...params, comercial: state.selectedComercial.id }
        let { data } = await axios.get(getters.getEndpointFromPath(state.paths.ttClienteAgendadosPath),
            {
                params: params
            })
        commit("agendados", data)
    },
}

const getters = {
    getEndpointFromPath: (_state, _unused, rootState) => endpoint => (
        rootState.general.host + endpoint
    ),
}

const mutations = {
    isOpenMove: (state, value) => {
        state.isOpenMove = value
    },
    agendados: (state, val) => {
        state.agendados = val;
    },
    requestedAgendados: (state, val) => {
        state.requestedAgendados = val;
    },
    selectedComercial: (state, val) => {
        state.selectedComercial = val;
    },
    rangoDate: (state, val) => {
        state.rangoDate = val;
    }
}

export default {
    namespaced: true,
    state,
    actions,
    getters,
    mutations
}